import { TYPE_OBJECT_SCHEDULE } from "../../shift/constants/shiftComprehensionConsts";

export const INIT_APPROVAL_CONFIG = {
  letterType: null,
  approvingInfo: [],
  note: ""
}

export const LIST_APPROVING = [
  {
    code: "HRM.APPROVAL.MANAGER",
    name: "Trưởng khoa/phòng"
  },
  {
    code: "HRM.APPROVAL.TCHC",
    name: "Tổ chức hành chính"
  },
  {
    code: "HRM.APPROVAL.DIRECTOR",
    name: "Giám đốc"
  }
];

export const LIST_TYPE_SCHEDULE = (lang: any) => [
  {
    code: TYPE_OBJECT_SCHEDULE.DIEU_DUONG,
    name: lang("SCHEDULE_CONFIG.TYPE.NURSE")
  },
  {
    code: TYPE_OBJECT_SCHEDULE.BAC_SI,
    name: lang("SCHEDULE_CONFIG.TYPE.DOCTOR")
  }
];